import React, { useContext } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../contexts/AuthContext/AuthContext";
import "./AdminDashboard.css";

// Clinician landing page (Admin Mode). Patient management (#31) and
// cross-patient statistics (#32) are linked here and built out separately.
const AdminDashboard = () => {
  const { user } = useContext(AuthContext);

  return (
    <div className="admin-dashboard">
      <h1 className="admin-dashboard-title">Admin Mode</h1>
      <p className="admin-dashboard-greeting">
        Welcome{user?.first_name ? `, ${user.first_name}` : ""}.
      </p>
      <nav className="admin-dashboard-links" aria-label="Admin sections">
        <Link className="admin-dashboard-card" to="/admin/patients">
          Manage patients
        </Link>
        <Link className="admin-dashboard-card" to="/admin/stats">
          Patient statistics
        </Link>
      </nav>
    </div>
  );
};

export default AdminDashboard;
